import React, { useEffect, useState,useContext } from 'react'
import { Box } from '../../designSystem'
import {
  CollapseHelpContainer,
  CollapseListContainer,
  CollapseListContainerItems,
  ErrorText,
  InfoExpandText,
  RevenueTab,
} from './style'
import AnalyticsChartCreator from './AnalyticsChartCreator'
import RevenueCards from './RevenueCards'
import ChevronRight from '../../components/Images/ChevronRight'
import ChevronDown from '../../components/Images/ChevronDown'
import { AccountContext } from '../../providers/accountProvider'

export default function Revenue({
  payingUser,
  netRevenue,
  revenueShare,
  incentive,
  monthlyRevenue,
  chapterRevenue,
  monthlyRevenueShare,
  chapterRevenueShare,
  bookSelected,
  isSeries = false
}) {
  const [bookMonthlyRevenue, updateBookMonthlyRevenue] = useState(null)
  const [bookChapterRevenue, updateBookChapterRevenue] = useState(null)
  const [bookRevenueShare, updateBookRevenueShare] = useState(null)
  const [bookChapterShare, updateBookChapterShare] = useState(null)
  const [collapseHelp, updateCollapseHelp] = useState(true)
  const { user } = useContext(AccountContext)
  const hindiUser=(user?.languages==='hindi')

  useEffect(() => {
    if (monthlyRevenue.length > 0) {
      updateBookMonthlyRevenue({
        labels: monthlyRevenue.map((data) => data.date),
        datasets: [
          {
            label: `Monthly Revenue ${isSeries && !hindiUser ? '$' : '₹'}`,
            data: monthlyRevenue?.map((data) => Number(data.value.toFixed(2))),
            fill: false,
            backgroundColor: 'rgba(125,197,245,0.67)',
            borderColor: '#2196f3',
            tension: 0.2,
          },
        ],
      })
    }
    if (chapterRevenue.length > 0) {
      updateBookChapterRevenue({
        labels: chapterRevenue.map((data) => `Ch: ${data.chapter}`),
        datasets: [
          {
            label: ` ${isSeries ? `Episode Revenue ${!hindiUser ? '$' : '₹'}` : 'Chapter Revenue ₹'}`,
            data: chapterRevenue?.map((data) => Number(data.value.toFixed(2))),
            fill: false,
            backgroundColor: 'rgba(125,197,245,0.67)',
            borderColor: '#2196f3',
            tension: 0.2,
          },
        ],
      })
    }
    if (monthlyRevenueShare.length > 0) {
      updateBookRevenueShare({
        labels: monthlyRevenueShare.map((data) => data.date),
        datasets: [
          {
            label: `Monthly Revenue Share ${isSeries && !hindiUser ? '$' : '₹'}`,
            data: monthlyRevenueShare?.map((data) =>
              Number(data?.value?.toFixed(2)) || 0
            ),
            fill: false,
            backgroundColor: 'rgba(125,197,245,0.67)',
            borderColor: '#2196f3',
            tension: 0.2,
          },
        ],
      })
    }
    if (chapterRevenueShare.length > 0) {
      updateBookChapterShare({
        labels: chapterRevenueShare.map((data) => `Ch: ${data.chapter}`),
        datasets: [
          {
            label: `${isSeries ? `Episode Revenue Share ${!hindiUser ? '$' : '₹'}` : 'Chapter Revenue Share ₹'}`,
            data: chapterRevenueShare?.map((data) =>
              Number(data?.value?.toFixed(2)) || 0
            ),
            fill: false,
            backgroundColor: 'rgba(125,197,245,0.67)',
            borderColor: '#2196f3',
            tension: 0.2,
          },
        ],
      })
    }
  }, [])

  const isMobile = window.screen.width < 600

  if (
    !bookMonthlyRevenue &&
    !bookChapterRevenue &&
    !bookRevenueShare &&
    !bookChapterShare
  ) {
    return (
      <Box my="8px">
        <ErrorText>
          Data of this category not found, please try again later
        </ErrorText>
      </Box>
    )
  }

  return (
    <Box>
      <Box backgroundColor="surface.foreground" p={16} my={10}>
        <InfoExpandText onClick={() => updateCollapseHelp(!collapseHelp)}>
          <span>When & How do I get paid ?</span>
          {collapseHelp ? (
            <ChevronRight style={{ float: 'right' }} width={25} height={25} />
          ) : (
            <ChevronDown style={{ float: 'right' }} width={25} height={25} />
          )}
        </InfoExpandText>
        {!collapseHelp && (
          <CollapseHelpContainer>
            Post the contract review process,
            <br />
            We pay our writers in a monthly cycle, by 2nd week of the subsequent
            month
            <CollapseListContainer>
              <li>
                Any deficit in the revenue share reward amount you have received
                for previous months will be processed in the subsequent months.
              </li>
              <CollapseListContainerItems>
                {`If the total rewards for a month is less than ${isSeries && !hindiUser ? '$' : '₹'}100, then we will
                process the payment for it when the overall deficit or any
                subsequent Month’s Revenue Share >= ${isSeries && !hindiUser ? '$' : '₹'}100.. `}
              </CollapseListContainerItems>
              <CollapseListContainerItems>
              { !isSeries && !hindiUser ? "Revenue Share is calculated based on revenue share % & the detection of Tax & payment gateway charges from the Revenue":
                "Revenue Share is calculated based on  Net revenue ( after detection any payment gateway & operational charges)"}
              </CollapseListContainerItems>
            </CollapseListContainer>
          </CollapseHelpContainer>
        )}
      </Box>
      <RevenueTab style={{ display: `${isMobile ? 'block' : 'flex'}` }}>
        <RevenueCards
          isMobile={isMobile}
          title="Paying Users"
          showCurrency={false}
          ToastTxt="Shows the total unique users who spent coins that are bought."
          value={payingUser}
          bookSelected={bookSelected}
          module="payingusers_infoicon"
        />
        <RevenueCards
          isMobile={isMobile}
          title="Revenue"
          showCurrency
          ToastTxt={`Shows the lifetime Revenue of the ${isSeries? 'series' :'novel'}`}
          value={`${isSeries && !hindiUser ? '$' : '₹'} ${netRevenue}`}
          bookSelected={bookSelected}
          module="revenue_infoicon"
        />
        <RevenueCards
          isMobile={isMobile}
          title="Revenue Share"
          showCurrency
          ToastTxt={`Shows the lifetime Revenue Share of the ${isSeries? 'series' :'novel'}`}
          value={`${isSeries && !hindiUser ? '$' : '₹'} ${revenueShare}`}
          bookSelected={bookSelected}
          module="revenueshare_infoicon"
        />
        <RevenueCards
          isMobile={isMobile}
          title="Total Incentive"
          showCurrency
          ToastTxt={!isSeries ?"Shows the lifetime Incentive earned for the novel":"Shows the lifetime Incentives earned by the series"}
          value={`${isSeries && !hindiUser ? '$' : '₹'} ${incentive}`}
          bookSelected={bookSelected}
          module="totalincentive_infoicon"
        />
      </RevenueTab>
      {bookMonthlyRevenue && (
        <AnalyticsChartCreator
          isMobile={isMobile}
          chartData={bookMonthlyRevenue}
          chartTitle={`Monthly Revenue ${isSeries && !hindiUser ? '$' : '₹'}`}
          ToastTxt={`This Graph shows the “Revenue” earned by the ${isSeries? 'series' :'novel'} in the given month`}
          tab="analytics_revenue"
          bookSelected={bookSelected}
          module="monthlyrevenue_infoicon"
        />
      )}
      {bookChapterRevenue && (
        <Box mt={10}>
          <AnalyticsChartCreator
            isMobile={isMobile}
            chartData={bookChapterRevenue}
            chartTitle={`${isSeries ? `Episode Revenue ${ !hindiUser ? '$' : '₹'}` : 'Chapter Revenue ₹'}`}
            ToastTxt={`This Graph shows the “Revenue” earned by the ${isSeries? 'episode' :'chapter'}.`}
            tab="analytics_revenue"
            bookSelected={bookSelected}
            module="chapterrevenue_infoicon"
          />
        </Box>
      )}
      {bookRevenueShare && (
        <Box mt={10}>
          <AnalyticsChartCreator
            isMobile={isMobile}
            chartData={bookRevenueShare}
            chartTitle={`Monthly Revenue Share ${isSeries && !hindiUser ? '$' : '₹'}`}
            ToastTxt={`This Graph shows the “Revenue Share” earned by the ${isSeries? 'series' :'novel'} in the given month.`}
            tab="analytics_revenue"
            bookSelected={bookSelected}
            module="monthlyrevenueshare_infoicon"
          />
        </Box>
      )}
      {bookChapterShare && (
        <Box mt={10}>
          <AnalyticsChartCreator
            isMobile={isMobile}
            chartData={bookChapterShare}
            chartTitle={` ${isSeries ? `Episode Revenue Share ${ !hindiUser ? '$' : '₹'}` : 'Chapter Revenue Share ₹'}`}
            ToastTxt={`This Graph shows the “Revenue Share” earned by the ${isSeries? 'episode' :'chapter'}.`}
            tab="analytics_revenue"
            bookSelected={bookSelected}
            module="chapterrevenueshare_infoicon"
          />
        </Box>
      )}
    </Box>
  )
}
